
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { resetProject, updateProjectState } from "../../redux/slices/project";
import { useProject } from "../../shared";
import Page from "../templates/Page";
import Canvas from "./Canvas";
import Controls from "./controls/Controls";
import Timeline from "./timeline/Timeline";

function Project() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { project } = useProject(id || "-1");

  useEffect(() => {
    return () => {
      dispatch(resetProject());
    }
  }, [dispatch]);

  useEffect(() => {
    if (!project) return;
    dispatch(updateProjectState(project));
  }, [project, dispatch]);

  if (!project) {
      return (
          <div>
              Project Not Found
          </div>
      )
  }

  console.log("rerender Project-----------------")
  return (
    <>
      <Page>
        <Controls project={project} />
        <Canvas project={project} />
        <Timeline project={project} />
      </Page>
    </>
  );
}

export default Project;